import type { MailboxInfo } from "owa-client-types";
import type { SearchTableQuery } from "owa-mail-list-search";
import { isOriginalGenWebQueryOnTypeExperienceEnabled } from "owa-mail-search";
import { SearchProvider } from "owa-search-service";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";

export default function shouldEnableOriginalQueryOnTypeSectionRedesign(searchTableQuery: SearchTableQuery, mailboxInfo: MailboxInfo): boolean {
    const isQueryOnTypeProvider = searchTableQuery.searchProvider === SearchProvider.Substrate ||
        searchTableQuery.searchProvider === SearchProvider.SubstrateV2;
    
    return (searchTableQuery.scenarioType === "mail" &&
        searchTableQuery.listViewType === 1 &&
        isQueryOnTypeProvider &&
        isOriginalGenWebQueryOnTypeExperienceEnabled(mailboxInfo));
}
